import HugImg from "../../../assets/img/Hug.png";

/** Corner brackets echoing the brand mark (blue + orange accent). */
function BrandFrame({ children }) {
	return (
		<div className="relative mx-auto w-full max-w-[320px] px-5 py-5">
			<span
				className="pointer-events-none absolute top-0 right-0 h-10 w-10 rounded-tr-2xl border-t-[3px] border-r-[3px] border-cta"
				aria-hidden
			/>
			<span
				className="pointer-events-none absolute top-0 left-0 h-8 w-8 rounded-tl-2xl border-t-[3px] border-l-[3px] border-darkBlue"
				aria-hidden
			/>
			<span
				className="pointer-events-none absolute bottom-0 right-0 h-8 w-8 rounded-br-2xl border-b-[3px] border-r-[3px] border-darkBlue"
				aria-hidden
			/>
			<span
				className="pointer-events-none absolute bottom-0 left-0 h-10 w-10 rounded-bl-2xl border-b-[3px] border-l-[3px] border-darkBlue"
				aria-hidden
			/>
			{children}
		</div>
	);
}

export default function AuthIllustration() {
	return (
		<div className="flex flex-col items-center gap-3 pb-1 text-center">
			<BrandFrame>
				<div className="rounded-2xl bg-white/95 border border-[#E2E8F0] px-5 py-4 shadow-[0_8px_32px_rgba(39,106,166,0.08)]">
					<img
						src={HugImg}
						className="w-[120px] sm:w-[132px] h-auto mx-auto block"
						alt=""
						aria-hidden
					/>
				</div>
			</BrandFrame>
			<p className="font-Vazir-500 text-[13px] text-grayText leading-6 max-w-[280px]">
				فضایی برای یادگیری، همراهی و مراقبت از سلامت روان
			</p>
		</div>
	);
}
